import React, { Component } from 'react';

class getProductosActivos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productos: []
    };
  }

  toggleProducto = (id_producto_sucursal, activo) => {
    const url = this.props.dir_url + "webapp/getProductosIStatus";
    const token = this.props.token;
    const obj = { accion:'productosact',id_sucursal: this.props.id_sucursal, id_producto_sucursal, activo: activo ? 1 : 0, token };

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
      .then(() => this.getProductos()); // Actualizar luego del cambio
  }

  toggleAllProductos = (estado) => {
    const url = this.props.dir_url + "webapp/getProductosActAll";
    const token = this.props.token;
    const obj = {accion:'productosact',  id_sucursal: this.props.id_sucursal,estado: estado ? 1 : 0, token };

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    }).then(res => res.json())
      .then(() => this.getProductos()); // Refresca después de aplicar el cambio
  }

  getProductos = () => {
    const url = this.props.dir_url + "webapp/getProductosAct";
    const token = this.props.token;
    const obj = { accion:'productosact', id_sucursal: this.props.id_sucursal, token };

    fetch(url, {
      method: 'POST',
      body: JSON.stringify(obj),
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(res => res.json())
      .then((data) => {
        if (data[0].status === "ok") {
          this.setState({
            productos: data[0].msg
          });
        }
      })
      .catch(console.log);
  }

  generar_tabla() {
    const { productos } = this.state;
    return (
    <div className="cssversion_pw100 cssversion_ph100" style={{"overflowY":"auto"}}>
        <table className='tb_pedidos' style={{ width: "100%" }}>
            <thead>
            <tr>
                <th>Producto</th>
                <th>Estado</th>
            </tr>
            </thead>
            <tbody>
            {productos && productos.map(producto => (
                <tr key={producto.id_producto_sucursal}>
                <td>{producto.producto}</td>
                <td>
                    <label className="switch">
                    <input
                        type="checkbox"
                        checked={Number(producto.activo) === 1}
                        onChange={() => this.toggleProducto(producto.id_producto_sucursal, Number(producto.activo) === 0)}
                    />
                    <span className="slider round"></span>
                    </label>
                </td>
                </tr>
            ))}
            </tbody>
        </table>
      </div>
    );
  }

  regresar = () => {
    this.props.get_salir_vista_pedido();
  }

  render() {
    return (
      <React.Fragment>
        <div className="cssversion_menu cssversion_colorwhite" style={{ color: "black" }}>
          <div className="cssversion_pw100 cssversion_ph10 cssversion_colorblanco" style={{ display: "flex" }}>
            <div className="cssversion_pw10 cssversion_contentCenter" onClick={this.regresar}>
              <img className="icon-global" alt="Regresar" src={require('../image/12355707351582004488-128.png')} />
            </div>
            <div className="cssversion_pw90 cssversion_contentCenter">
              <button onClick={() => this.toggleAllProductos(true)}>Activar Todos</button>
              <button onClick={() => this.toggleAllProductos(false)} style={{ marginLeft: 10 }}>Desactivar Todos</button>
            </div>
          </div>
          <div className="cssversion_pw100 cssversion_ph90" style={{ display: "flex" }}>
            {this.generar_tabla()}
          </div>
        </div>

        {/* Estilos del interruptor */}
        <style>{`
          .switch {
            position: relative;
            display: inline-block;
            width: 50px;
            height: 24px;
          }
          .switch input {
            opacity: 0;
            width: 0;
            height: 0;
          }
          .slider {
            position: absolute;
            cursor: pointer;
            top: 0; left: 0;
            right: 0; bottom: 0;
            background-color: #ccc;
            transition: .4s;
            border-radius: 24px;
          }
          .slider:before {
            position: absolute;
            content: "";
            height: 18px;
            width: 18px;
            left: 3px;
            bottom: 3px;
            background-color: white;
            transition: .4s;
            border-radius: 50%;
          }
          input:checked + .slider {
            background-color: #2196F3;
          }
          input:checked + .slider:before {
            transform: translateX(26px);
          }
        `}</style>
      </React.Fragment>
    );
  }

  componentDidMount() {
    this.getProductos();
  }
}

export default getProductosActivos;
